var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", [
    _c("div", { staticClass: "section" }, [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "orders" },
        _vm._l(_vm.orders, function(order) {
          return _c(
            "div",
            { key: order.id, staticClass: "card" },
            [
              _c("div", { staticClass: "professional-image" }, [
                _c("img", {
                  attrs: {
                    src: order.professional.account.profile.profile_picture,
                    alt: order.professional.account.first_name
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "order-informations" }, [
                _c("div", { staticClass: "name" }, [
                  _vm._v(
                    _vm._s(order.professional.account.first_name) +
                      " " +
                      _vm._s(order.professional.account.last_name)
                  )
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "dia " +
                      _vm._s(
                        _vm._f("formatDate")(
                          order.schedule_event.starts_at,
                          "DD/MM/Y [às] H[h]"
                        )
                      ) +
                      " com duração de " +
                      _vm._s(
                        _vm._f("secToHours")(
                          order.schedule_event.duration,
                          true
                        )
                      )
                  )
                ])
              ]),
              _vm._v(" "),
              _c(
                "router-link",
                {
                  staticClass: "btn bg-purple-outline btn-small mt-10",
                  attrs: { to: "pedidos/" + order.id }
                },
                [_vm._v("ver mais")]
              )
            ],
            1
          )
        })
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "title mt-20" }, [_vm._v("Pedidos")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b37823ba", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b37823ba","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Cycle/Orders/Mobile.vue
// module id = null
// module chunks = 